// @flow
import { Map } from "immutable";
import { createSelector } from "reselect";

export const userIdSelector = (state: Map<string, any>) =>
  state.getIn(["security", "userId"]);
const userPrivilegesSelector = (state: Map<string, any>) =>
  state.getIn(["security", "privileges"]);
const routePrivilegesSelector = (_, props) => props.routePrivileges || [];

export const userAccessTokenSelector = (state: Map<string, any>) =>
  state.getIn(["security", "accessToken"]);

// derived selectors
export const authenticatedSelector = createSelector(
  userAccessTokenSelector,
  accessToken => !!accessToken
);
export const hasPrivilegesRequiredSelector = createSelector(
  userPrivilegesSelector,
  routePrivilegesSelector,
  (userPrivileges, routePrivileges) => {
    return userPrivileges.isSuperset(routePrivileges);
  }
);

export const securityErrorSelector = (state: Map<string, any>) =>
  state.getIn(["security", "error"])

export const securityIsFetchingSelector = (state: Map<string, any>) =>
  state.getIn(["security", "isFetchingData"]);


export const userRoleSelector = (state: Map<string, any>) =>
  state.getIn(["security", "role"]);

export const hasRequiredRoleSelector = (state, ownProps) => {
  const userRole = userRoleSelector(state)
  const routeRequiredRole = ownProps.requiredRole
  return userRole === routeRequiredRole
}

export const locationIdSelector = (state: Map<string, any>) =>
  state.getIn(["security", "locationId"]);



// WEBPACK FOOTER //
// ./src/security/securitySelectors.js